import http from '../../../utils/services/http';

export const updateEmailPreferences = ({ email, unsubscribeType }) => {
    const httpConfig = {
        url: 'users/email/preferences',
        method: 'put',
        data: {
            email,
            unsubscribeType,
        },
    };

    return http(httpConfig);
};
